module.exports = __webpack_public_path__ + "static/img/icon-email.6af590fe.png";